import { Color, Flex, Icon, Spacing, Text, Tooltip } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { BankLine } from '@modules-deprecated/bankReconciliation/types'

import { BankTransaction } from '../BankTransaction'
import * as Styled from './styles'

interface PendingBankTransactionsSectionProps {
  pendingTransactions: BankLine[]
  currency?: string
}

export const PendingBankTransactionsSection = ({
  pendingTransactions,
  currency,
}: PendingBankTransactionsSectionProps): ReactElement | null => {
  const { t } = useTranslation()

  if (pendingTransactions.length === 0) {
    return null
  }

  return (
    <Flex flexDirection="column" gap={Spacing.S8}>
      <Styled.SectionHeader>
        <Text colorVariant="discreet">{t('bank_transactions.pending_section.title')}</Text>
        <Tooltip placement="top" label={t('bank_transactions.pending_section.tooltip')}>
          <Icon icon="info" color={Color.Grey300} />
        </Tooltip>
      </Styled.SectionHeader>
      <Flex flexDirection="column">
        {pendingTransactions.map((transaction) => (
          <BankTransaction key={transaction.id} transaction={transaction} currency={currency} isPending />
        ))}
      </Flex>
    </Flex>
  )
}
